module.exports = __webpack_public_path__ + "static/media/advantage3.1e79c925.png";